import React, { Fragment } from 'react';
import { HASHTAG_TYPE as HASHTAG_TYPE$1 } from 'ricos-content';
import { Decoration_Type, Link_Target } from 'ricos-schema';

const DEFAULTS = {
  config: {
    createHref: (decoratedText) => `/search/posts?query=${encodeURIComponent("#")}${decoratedText}`,
    onClick: (event) => {
      event.preventDefault();
    }
  }
};

const HASHTAG_TYPE = "wix-draft-plugin-hashtag";

var styles = {"fontElementMap":"YheTb","hashtag":"SOXgS"};

const hashtagRegex = new RegExp("(\\s|^)#(\\p{L}|\\d|_)+", "gmu");

const hasLink = (node) => {
  var _a, _b;
  return (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(
    (decoration) => [Decoration_Type.LINK, Decoration_Type.ANCHOR, Decoration_Type.MENTION].includes(
      decoration.type
    )
  );
};
const decorator = (text, contextualData) => {
  var _a;
  const settings = contextualData.config[HASHTAG_TYPE$1] || {};
  const { createHref, onClick } = settings;
  const { anchorTarget = Link_Target.SELF } = contextualData;
  const target = `_${(_a = anchorTarget == null ? void 0 : anchorTarget.toLowerCase) == null ? void 0 : _a.call(anchorTarget)}`;
  const href = createHref ? createHref(text) : null;
  const decoratedOnClick = (e) => onClick(e, text);
  const onKeyDown = (e) => (e.key === "Enter" || e.key === " ") && onClick(e, text);
  const key = `hashtag-${text}`;
  return href ? /* @__PURE__ */ React.createElement(
    "a",
    {
      key,
      className: styles.hashtag,
      href,
      target,
      onClick: decoratedOnClick,
      onKeyDown
    },
    /* @__PURE__ */ React.createElement("span", null, text)
  ) : /* @__PURE__ */ React.createElement("span", { key, className: styles.hashtag }, text);
};
const nodeViewDecorator = {
  rule: (node) => {
    var _a;
    return !!(((_a = node.textData) == null ? void 0 : _a.text.match(hashtagRegex)) && !hasLink(node));
  },
  decorate: ({ node, context }) => {
    const hashtags = [];
    const spans = [];
    const { text = "" } = node.textData || {};
    Array.from(text.matchAll(hashtagRegex)).forEach((match) => {
      const hash = match[0];
      let hashLength = hash.length;
      let from = match.index || 0;
      if (!hash.startsWith("#")) {
        from++;
        hashLength--;
      }
      const to = from + hashLength;
      hashtags.push([from, to]);
    });
    let start = 0;
    const end = text.length;
    hashtags.forEach(([from, to]) => {
      if (from > start) {
        spans.push(/* @__PURE__ */ React.createElement("span", { key: `${text}-${start}` }, text.substring(start, from)));
      }
      spans.push(
        /* @__PURE__ */ React.createElement(Fragment, { key: `${text}-${from}` }, decorator(text.substring(from, to), context))
      );
      start = to;
    });
    const lastHashTag = hashtags[hashtags.length - 1][1];
    if (lastHashTag < end) {
      spans.push(/* @__PURE__ */ React.createElement("span", { key: `${text}-${end}` }, text.substring(lastHashTag, end)));
    }
    return /* @__PURE__ */ React.createElement(Fragment, { key: "hastagContainer" }, spans);
  },
  isText: true
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginHashtag = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: HASHTAG_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};

export { pluginHashtag };
//# sourceMappingURL=viewer.js.map
